import { ModalsKey } from '@/enums/modalsKey';
import LastRoundsModalContent from './Content';
import LastMatchesModal from '../../LastMatches/Modal';

export default function LastRoundsModal() {
  return (
    <LastMatchesModal modal={ModalsKey.LastRounds} title="last_rounds_title">
      <LastRoundsModalContent />
    </LastMatchesModal>
  );
}
